var map = {
	"./admin/pickups/edit": 10,
	"./admin/pickups/edit.js": 10,
	"./admin/top/products/edit": 19,
	"./admin/top/products/edit.js": 19,
	"./contacts": 5,
	"./contacts/": 5,
	"./contacts/index": 5,
	"./contacts/index.js": 5,
	"./recipes/advices": 20,
	"./recipes/advices.js": 20,
	"./recipes/contents": 21,
	"./recipes/contents.js": 21,
	"./recipes/ingredients": 22,
	"./recipes/ingredients.js": 22,
	"./recipes/new": 23,
	"./recipes/new.js": 23,
	"./recipes/preparations": 24,
	"./recipes/preparations.js": 24,
	"./recipes/products/new": 25,
	"./recipes/products/new.js": 25,
	"./recipes/tags/cookingStyles": 6,
	"./recipes/tags/cookingStyles.js": 6,
	"./recipes/tags/genres": 7,
	"./recipes/tags/genres.js": 7,
	"./recipes/tags/ingredients": 8,
	"./recipes/tags/ingredients.js": 8,
	"./recipes/tags/new": 26,
	"./recipes/tags/new.js": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;